import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, Fragment as _Fragment } from "vue"

const _hoisted_1 = ["aria-label"]
const _hoisted_2 = { class: "top" }
const _hoisted_3 = ["aria-label"]
const _hoisted_4 = ["aria-label"]
const _hoisted_5 = ["aria-label"]
const _hoisted_6 = ["aria-label"]
const _hoisted_7 = ["aria-label"]
const _hoisted_8 = ["aria-label"]
const _hoisted_9 = ["aria-label"]
const _hoisted_10 = {
  key: 0,
  class: "mdi mdi-weather-night"
}
const _hoisted_11 = {
  key: 1,
  class: "mdi mdi-white-balance-sunny"
}
const _hoisted_12 = ["aria-label"]
const _hoisted_13 = { class: "locale-text" }
const _hoisted_14 = { class: "bottom" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("button", {
      class: _normalizeClass(["burger-btn", { 'menu-open': _ctx.isMenuOpen }]),
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggleMenu && _ctx.toggleMenu(...args))),
      "aria-label": _ctx.isMenuOpen ? 'Close menu' : 'Open menu'
    }, [
      _createElementVNode("span", {
        class: _normalizeClass(["burger-line", { 'open': _ctx.isMenuOpen }])
      }, null, 2),
      _createElementVNode("span", {
        class: _normalizeClass(["burger-line", { 'open': _ctx.isMenuOpen }])
      }, null, 2),
      _createElementVNode("span", {
        class: _normalizeClass(["burger-line", { 'open': _ctx.isMenuOpen }])
      }, null, 2)
    ], 10, _hoisted_1),
    _createElementVNode("div", {
      class: _normalizeClass(["backdrop", { 'active': _ctx.isMenuOpen }]),
      onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.closeMenu && _ctx.closeMenu(...args)))
    }, null, 2),
    _createElementVNode("header", {
      class: _normalizeClass(["header", { 'mobile-open': _ctx.isMenuOpen }])
    }, [
      _createElementVNode("div", _hoisted_2, [
        _withDirectives(_createElementVNode("a", {
          onClick: _cache[2] || (_cache[2] = ($event: any) => {_ctx.navigateToHome(); _ctx.closeMenu()}),
          class: _normalizeClass(["mdi mdi-home", { 'active': _ctx.activeSection === 'home' }]),
          role: "button",
          "aria-label": _ctx.$t('nav.home'),
          tabindex: "0"
        }, null, 10, _hoisted_3), [
          [_directive_tooltip, _ctx.$t('nav.home')]
        ]),
        _withDirectives(_createElementVNode("a", {
          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.navigateToInfra())),
          class: _normalizeClass(["mdi mdi-server-network desktop-only", { 'active': _ctx.activeSection === 'infra' }]),
          role: "button",
          "aria-label": _ctx.$t('nav.infrastructure'),
          tabindex: "0"
        }, null, 10, _hoisted_4), [
          [_directive_tooltip, _ctx.$t('nav.infrastructure')]
        ]),
        _withDirectives(_createElementVNode("a", {
          onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.navigateToProjects())),
          class: _normalizeClass(["mdi mdi-rocket-launch-outline desktop-only", { 'active': _ctx.activeSection === 'projects' }]),
          role: "button",
          "aria-label": _ctx.$t('nav.projects'),
          tabindex: "0"
        }, null, 10, _hoisted_5), [
          [_directive_tooltip, _ctx.$t('nav.projects')]
        ]),
        _withDirectives(_createElementVNode("a", {
          onClick: _cache[5] || (_cache[5] = ($event: any) => {_ctx.navigateToAbout(); _ctx.closeMenu()}),
          class: _normalizeClass(["mdi mdi-information", { 'active': _ctx.activeSection === 'about' }]),
          role: "button",
          "aria-label": _ctx.$t('nav.about'),
          tabindex: "0"
        }, null, 10, _hoisted_6), [
          [_directive_tooltip, _ctx.$t('nav.about')]
        ]),
        _withDirectives(_createElementVNode("a", {
          onClick: _cache[6] || (_cache[6] = ($event: any) => {_ctx.navigateToSkills(); _ctx.closeMenu()}),
          class: _normalizeClass(["mdi mdi-account-cog", { 'active': _ctx.activeSection === 'skills' }]),
          role: "button",
          "aria-label": _ctx.$t('nav.skills'),
          tabindex: "0"
        }, null, 10, _hoisted_7), [
          [_directive_tooltip, _ctx.$t('nav.skills')]
        ]),
        _withDirectives(_createElementVNode("a", {
          onClick: _cache[7] || (_cache[7] = ($event: any) => {_ctx.navigateToResume(); _ctx.closeMenu()}),
          class: _normalizeClass(["mdi mdi-file-document", { 'active': _ctx.activeSection === 'resume' }]),
          role: "button",
          "aria-label": _ctx.$t('nav.cv'),
          tabindex: "0"
        }, null, 10, _hoisted_8), [
          [_directive_tooltip, _ctx.$t('nav.cv')]
        ])
      ]),
      _createElementVNode("button", {
        onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.toggleTheme && _ctx.toggleTheme(...args))),
        class: "theme-toggle-btn",
        "aria-label": _ctx.colorStore.isLightTheme ? 'Switch to dark mode' : 'Switch to light mode'
      }, [
        (_ctx.colorStore.isLightTheme)
          ? (_openBlock(), _createElementBlock("span", _hoisted_10))
          : (_openBlock(), _createElementBlock("span", _hoisted_11))
      ], 8, _hoisted_9),
      _withDirectives((_openBlock(), _createElementBlock("button", {
        onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.toggleLocale && _ctx.toggleLocale(...args))),
        class: "locale-toggle-btn",
        "aria-label": _ctx.localeStore.isFrench ? 'Switch to English' : 'Passer en Français'
      }, [
        _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.localeStore.currentLocale.toUpperCase()), 1)
      ], 8, _hoisted_12)), [
        [_directive_tooltip, _ctx.localeStore.isFrench ? 'Switch to English' : 'Passer en Français']
      ]),
      _createElementVNode("div", _hoisted_14, [
        _withDirectives(_createElementVNode("a", {
          href: "https://www.linkedin.com/in/rapha%C3%ABl-girardy-623b4a265/",
          target: "_blank",
          class: "mdi mdi-linkedin",
          "aria-label": "LinkedIn profile",
          rel: "noopener noreferrer",
          onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.trackSocialClick('linkedin')))
        }, null, 512), [
          [_directive_tooltip, 'LinkedIn']
        ]),
        _withDirectives(_createElementVNode("a", {
          href: "https://github.com/EvantAiI",
          target: "_blank",
          class: "mdi mdi-github",
          "aria-label": "GitHub profile",
          rel: "noopener noreferrer",
          onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.trackSocialClick('github')))
        }, null, 512), [
          [_directive_tooltip, 'GitHub']
        ]),
        _withDirectives(_createElementVNode("a", {
          href: "mailto:raphael.girardy@outlook.com",
          class: "mdi mdi-gmail",
          "aria-label": "Send email",
          onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.trackSocialClick('email')))
        }, null, 512), [
          [_directive_tooltip, 'Mail']
        ])
      ])
    ], 2)
  ], 64))
}